export class FiltrosDnSubasta{
    
    IdAdq : string = '';
    Moneda : number = 0;
    FechaIni : string = "";
    FechaFin : string = "";
}